var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("../assets/rolling.gif")}}),_c('h4',{staticClass:"mt-3"},[_vm._t("default")],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }